let getBrand = localStorage.getItem('brand');
let getModal = localStorage.getItem('modal');
let getVariant = localStorage.getItem('variant');
let getSubVariant = localStorage.getItem('subvariant');
// checkSelectVisibility('modal');
checkSelectVisibility('variant');
checkSelectVisibility('subvariant');

if(getBrand){
  let item = document.getElementById('brand');
  item.value = getBrand;
  updateModels(item, 'brand', 'modal');
}
if(getModal){
   let itemModal = document.getElementById('modal');
   itemModal.value = getModal;
  updateModels(itemModal, 'modal', 'variant');
}
if(getVariant){
  let itemModal = document.getElementById('variant');
   itemModal.value = getVariant;
  updateModels(itemModal, 'variant', 'subvariant');
  // document.getElementById('variant').value = getVariant;
  // goToCollection();
}
if(getSubVariant){
  document.getElementById('subvariant').value = getSubVariant;
  goToCollection();
}



function updateModels(selectItem, option, id) {
    const brand = document.getElementById(option).value;
    const selectElement = document.getElementById(id);
    const optionsToHide = selectElement.querySelectorAll('option');
    const variantDropdown = document.getElementById('my_button');
  const clearButton = document.getElementById('clear_button');

  clearButton.style.display = "inline-block";
    
  let selectedOption = selectItem.options[selectItem.selectedIndex];
  let dataItemValue = selectedOption.getAttribute('data-link');
  
    if(id == 'modal'){
      document.getElementById('modal').selectedIndex = 0;
      document.getElementById('variant').selectedIndex = 0;
      document.getElementById('subvariant').selectedIndex = 0;
      localStorage.removeItem('modal'); 
      localStorage.removeItem('variant'); 
      localStorage.removeItem('subvariant'); 
    }else if(id == 'variant'){
      document.getElementById('variant').selectedIndex = 0;
      document.getElementById('subvariant').selectedIndex = 0;
       localStorage.removeItem('variant'); 
       localStorage.removeItem('subvariant'); 
    }
    optionsToHide.forEach((option) => {
        if (option.getAttribute("data-item") === brand) {
          // show the option
          option.hidden = false;
          // Optionally, enable the option
          option.disabled = false;
        }else{
           if (option.getAttribute("value") !== '') {
              // Hide the option
              option.hidden = true;
              // Optionally, disable the option
              option.disabled = true;
           }
        }
      checkSelectVisibility(id);
    });
     localStorage.setItem(option, selectedOption.getAttribute('value'));
     console.log('Value:', localStorage.getItem(option));
    if (dataItemValue) {
      variantDropdown.setAttribute("href", dataItemValue);
    }
    
  }

  function goToCollection() {
    const model = document.getElementById('subvariant').value;
    const selectElement = document.getElementById('subvariant');
    const variantDropdown = document.getElementById('my_button');
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    localStorage.setItem('subvariant', selectedOption.getAttribute('value'));
    console.log('subvariant:', localStorage.getItem('subvariant'));
    const dataItemValue = selectedOption.getAttribute("data-link");
    console.log(selectedOption, dataItemValue)
    if (dataItemValue) {
      variantDropdown.setAttribute("href", dataItemValue);
    }
  }

function checkSelectVisibility(selectId) {
  const select = document.getElementById(selectId);
  const options = Array.from(select.options);

  // Skip the first option (usually the default "Select..." prompt)
  const visibleOptions = options.slice(1).filter(option => !option.hidden && !option.disabled);

  // Show or hide the select box based on the presence of visible options
  if (visibleOptions.length === 0) {
    select.style.display = 'none';
  } else {
    select.style.display = 'inline-block'; // or 'block' based on your layout
  }
}

document.getElementById("clear_button").addEventListener("click", function () {
  document.getElementById('brand').selectedIndex = 0;
  document.getElementById('modal').selectedIndex = 0;
  document.getElementById('variant').selectedIndex = 0;
  document.getElementById('subvariant').selectedIndex = 0;
  localStorage.removeItem('brand'); 
  localStorage.removeItem('modal'); 
  localStorage.removeItem('variant'); 
  localStorage.removeItem('subvariant'); 
  this.style.display = "none"; 
  document.getElementById('variant').style.display = "none";
  document.getElementById('subvariant').style.display = "none";
});
